export const MAX_SALARY = 99_999_999;
